import React, { MouseEvent, ReactNode, useRef } from 'react';
import { Element } from '@/features/pacote/PacotesList/components/FilterBar/FilterBar.styles';
import SelectField from '@/components/form/SelectField/SelectField';
import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { usePacotesListContext } from '@/features/pacote/PacotesList/context';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import { useTranslations } from 'next-intl';

export interface FilterBarProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const FilterBar = ({ children, ...props }: FilterBarProps) => {
  const t = useTranslations('FilterBar');
  const ref = useRef<HTMLSelectElement>(null);
  const params = useSearchParams();
  const router = useRouter();

  const { data } = usePacotesListContext();
  const { destino, travelType, pacotes } = data;

  const orderSelected = sanitizeQueryParams(params.get('order'));
  const travelTypeParam = sanitizeQueryParams(params.get('travelType'));

  const handleChange = async (event: React.ChangeEvent) => {
    const value = ref.current?.value;

    let query: { destino: string; travelType?: string; order?: string } = {
      destino: destino.slug,
    };

    if (travelTypeParam && travelTypeParam === travelType?.slug) {
      query.travelType = travelType.slug;
    }

    if (value && ['', 'lower-price', 'higher-price', 'title'].includes(orderSelected.toLowerCase())) {
      query.order = value;
    }

    await router.push({
      pathname: '/pacotes/[destino]',
      query,
    });
  };
  return (
    <Element>
      <form onSubmit={(e) => e.preventDefault()}>
        <label htmlFor="orderFilter">{t('Ordem de Exibição')}:</label>
        <SelectField
          ref={ref}
          id="orderFilter"
          name="filter"
          onChange={handleChange}
          defaultValue={orderSelected}
          disabled={pacotes.length <= 1}
        >
          <option value="">{t('Relevância')}</option>
          <option value="lower-price">{t('Menor preço')}</option>
          <option value="higher-price">{t('Maior preço')}</option>
          <option value="title">{t('Nome pacote')}</option>
        </SelectField>
      </form>
    </Element>
  );
};

export default FilterBar;
